import React from 'react';
import { RestorePasswordForm } from '../../toolympus/components/auth';

const RestorePasswordContainer = () => {
    return <RestorePasswordForm restoreAPIPath="/api/restore-access/reset"/>
}

export default RestorePasswordContainer;